"use client"

import { useState } from "react"
import { List, X } from "lucide-react"
import { cn } from "@/lib/utils"

const sections = [
  { id: "overview", title: "Overview", number: "01" },
  { id: "channels", title: "Channel Adapters", number: "02" },
  { id: "message-flow", title: "Message Flow", number: "03" },
  { id: "architecture", title: "Architecture", number: "04" },
  { id: "configuration", title: "Configuration", number: "05" },
  { id: "getting-started", title: "Getting Started", number: "06" },
]

export function MobileTableOfContents() {
  const [isOpen, setIsOpen] = useState(false)

  const handleClick = (id: string) => {
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
      setIsOpen(false)
    }
  }

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(true)}
        className="lg:hidden fixed bottom-6 right-6 z-40 p-4 rounded-full bg-accent-primary text-primary-foreground shadow-lg"
        aria-label="Open table of contents"
      >
        <List className="h-5 w-5" />
      </button>

      {/* Overlay */}
      {isOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-background/80 backdrop-blur-sm z-50"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Drawer */}
      <div
        className={cn(
          "lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border rounded-t-2xl transition-transform duration-300",
          isOpen ? "translate-y-0" : "translate-y-full"
        )}
      >
        <div className="p-4">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-semibold text-foreground">Contents</h3>
            <button
              onClick={() => setIsOpen(false)}
              className="p-2 rounded-full hover:bg-muted"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          <nav className="space-y-1 max-h-[50vh] overflow-y-auto">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => handleClick(section.id)}
                className="w-full text-left px-3 py-3 text-sm rounded-md transition-colors text-muted-foreground hover:text-foreground hover:bg-muted/50 flex items-center gap-3"
              >
                <span className="text-xs opacity-60">{section.number}</span>
                {section.title}
              </button>
            ))}
          </nav>
        </div>
      </div>
    </>
  )
}
